import React from "react";
import { CheckCircle, AlertCircle } from "lucide-react";
import type { ValidationResult } from "../types";

interface BrandImportValidationResultsProps {
  validationResult: ValidationResult;
}

export const BrandImportValidationResults: React.FC<BrandImportValidationResultsProps> = ({
  validationResult,
}) => {
  return (
    <div className="space-y-4">
      <h3 className="text-lg font-medium">Validation Results</h3>

      <div className="grid grid-cols-2 gap-4">
        <div className="bg-green-50 p-4 rounded-lg">
          <div className="flex items-center space-x-2">
            <CheckCircle className="w-5 h-5 text-green-600" />
            <span className="font-medium text-green-900">Valid Rows</span>
          </div>
          <p className="text-2xl font-bold text-green-600">
            {validationResult.valid.length}
          </p>
        </div>

        <div className="bg-red-50 p-4 rounded-lg">
          <div className="flex items-center space-x-2">
            <AlertCircle className="w-5 h-5 text-red-600" />
            <span className="font-medium text-red-900">Invalid Rows</span>
          </div>
          <p className="text-2xl font-bold text-red-600">
            {validationResult.invalid.length}
          </p>
        </div>
      </div>

      {/* Show validation errors */}
      {validationResult.invalid.length > 0 && (
        <div className="bg-red-50 p-4 rounded-lg">
          <h4 className="font-medium text-red-900 mb-2">Validation Errors:</h4>
          <div className="space-y-2 max-h-40 overflow-y-auto">
            {validationResult.invalid.slice(0, 10).map((error, index) => (
              <div key={index} className="text-sm text-red-800">
                <strong>Row {error.row}:</strong> {error.errors.join(', ')}
              </div>
            ))}
            {validationResult.invalid.length > 10 && (
              <p className="text-sm text-red-600">
                ... and {validationResult.invalid.length - 10} more errors
              </p>
            )}
          </div>
        </div>
      )}
    </div>
  );
};
